import {
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';

import { CookieService } from '../../../common/services/cookie.service';
import { DeprecatedPopUpComponent } from '../../../ui/controls/pop-up/pop-up.component';

@Component({
	selector: 'app-authorization-enabled',
	templateUrl: './authorization-enabled.component.html',
	styleUrls: ['./authorization-enabled.component.less'],
	standalone: false,
})
export class AuthorizationEnabledComponent implements OnInit {

	@ViewChild(DeprecatedPopUpComponent, {static: true})
	private popUpComponent: DeprecatedPopUpComponent;

	constructor(
		private cookieService: CookieService,
	) { }

	public ngOnInit(): void {
		if (!this.cookieService.cookieEnabled()) {
			this.popUpComponent.open();
		}
	}

	public close(): void {
		this.popUpComponent.close();
	}

}
